<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('entities')"
      :columns="columns"
      :column_search="false"
      resource_url="/account-request/entity/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar -->
    <entity-modal ref="entity_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import EntityModal from "./entity_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  format_date_time,
  error_message,
} from "@/utils";

export default {
  name: "AccountRequestDataTable",
  components: {
    GenericTable,
    EntityModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("name"),
          data: (row) => row.name || "",
        },
        {
          title: this.$t("actions"),
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  this.edit(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  this.delete(row);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.entity_modal.show_modal();
    },
    edit(row) {
      this.$refs.entity_modal.edit_modal(row.uuid);
    },
    delete(row) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete entity?"), v, () => {
        del("/account-request/entity", { uuid: row.uuid })
          .then(() => {
            v.refresh_datatable();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
